import axios from "axios";
import API_URL from "../util/ApiUrl";

export const getSubdomain = () => {
	if (
		process.env.REACT_APP_NODE_ENV === "local" ||
		process.env.REACT_APP_NODE_ENV === "development"
	) {
		return "subDomain" in localStorage ? localStorage.getItem("subDomain") : "";
	} else {
		if (window.location.host.split(".")[0] === "login") {
			return "";
		} else {
			return window.location.host.split(".")[0];
		}
	}
};

// Detects an expired/invalid session response and forces a redirect to the
// login page so the user is not stuck on an authenticated page when the JWT
// is rejected by the gateway (HTTP 401) or the API (HTTP 400 "Bad Token").
export const handleSessionExpiry = (err) => {
	const error =
		err?.response === undefined || err.response.data === undefined
			? err?.message
			: err.response.data.message;

	const status = err?.response?.status;
	const isSessionExpired =
		status === 401 ||
		(status === 400 &&
			(error?.includes("Bad Token") ||
				error?.includes("User Not logged In")));

	if (!isSessionExpired) return false;

	const storedError = sessionStorage.getItem("axiosInterceptError");
	if (storedError === null) {
		sessionStorage.setItem(
			"axiosInterceptError",
			JSON.stringify("Bad Token: Access Denied!"),
		);
	}

	if (
		localStorage.getItem("userToken") &&
		localStorage.getItem("logout") === null
	) {
		localStorage.setItem("logout", true);
		const domain = sessionStorage.getItem("DomainDetails");
		const tab = localStorage.getItem("tabs");
		sessionStorage.clear();
		if (domain) sessionStorage.setItem("DomainDetails", domain);
		localStorage.clear();
		localStorage.setItem("apiHost", process.env.REACT_APP_API_LOCAL_URL);
		if (tab) localStorage.setItem("tabs", tab);
		if (
			window.location.pathname !== "/" &&
			!window.location.pathname.includes("/login")
		) {
			window.location.replace("/");
		}
	}
	return true;
};

const apiClientFactory = () => {
	const domain =
		sessionStorage.getItem("DomainDetails") !== null
			? sessionStorage.getItem("DomainDetails")
			: "";

	// const domain = 
	// 	localStorage.getItem("DomainDetails") !== null
	// 		? localStorage.getItem("DomainDetails")
	// 		: "";
	const apiClient = axios.create({
		baseURL: API_URL(),
		timeout: 300000,
		headers: {
			Authorization: `Bearer ${
				localStorage.getItem("userToken") || "no token"
			}`,
			domain: domain,
		},
	});

	apiClient.interceptors.response.use(
		(response) => response,
		(err) => {
			console.log("error from api", err);
			handleSessionExpiry(err);
			return Promise.reject(err);
		},
	);
	////console.log("SUB-DOMAIN", getSubdomain());
	return apiClient;
};

export default apiClientFactory;
